import React from 'react';
import { ModelSection, ModelSectionType } from '../types/ModelSection';
import { TailwindCard } from './Tailwind';
import TutorialStep from './Tutorial';
import { cn } from '../lib/utils';

export interface ModelSectionGridProps {
  sections: ModelSection[];
  onSectionClick: (section: ModelSection) => void;
  searchQuery?: string;
}

export default function ModelSectionGrid({
  sections,
  onSectionClick,
  searchQuery = '',
}: ModelSectionGridProps) {
  // Filtrer les sections selon la recherche
  const filteredSections = searchQuery
    ? sections.filter(section =>
        section.config.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        section.config.description.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : sections;


  return (
    <div className="px-8 py-8">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider">
          Model Sections
        </h3>
      </div>

      {/* Recherche - résultats */}
      {searchQuery && (
        <div className="mb-4 text-sm text-slate-600">
          {filteredSections.length === 0 ? (
            <p>No sections found for "{searchQuery}"</p>
          ) : (
            <p>
              Found {filteredSections.length} section{filteredSections.length !== 1 ? 's' : ''} for "{searchQuery}"
            </p>
          )}
        </div>
      )}

      {/* Grille de cartes */}
      <div className={cn(
        'grid gap-4',
        'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4'
      )}>
        {filteredSections.map((section, index) => {
          const card = (
            <TailwindCard
              key={section.config.id}
              id={section.config.id}
              icon={section.config.icon}
              title={section.config.name}
              description={section.config.description}
              onClick={() => onSectionClick(section)}
            />
          );

          // Wrap the second section card with tutorial step
          if (index === 1) {
            return (
              <TutorialStep key={section.config.id} tutorial='main' identifier='section_detail' display='block' position="none" marginTop={10} marginLeft={10}>
                {card}
              </TutorialStep>
            );
          }

          return card;
        })}
      </div>

      {/* Message si aucune section */}
      {filteredSections.length === 0 && !searchQuery && (
        <div className="text-center py-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-slate-100 mb-4">
            <span className="material-symbols-outlined text-slate-400 text-[32px]">
              folder_off
            </span>
          </div>
          <h3 className="text-lg font-semibold text-slate-900 mb-2">
            No sections available
          </h3>
          <p className="text-sm text-slate-500">
            Load a scenario to see its sections.
          </p>
        </div>
      )}

    </div>
  );
}
